import axios from 'axios';
import { getToken, removeToken, getSelectedTeam } from './auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Security managers pick a "team context" (see TeamSelector in Layout);
    // forward it so team-scoped endpoints (employees, reports, settings, etc.)
    // know which team they're acting on behalf of.
    const { id: selectedTeamId } = getSelectedTeam();
    if (selectedTeamId) {
      config.headers['X-Team-Id'] = selectedTeamId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRedirecting401 = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isLoginRequest = url.includes('/users/login');
    if (status === 401 && !isLoginRequest && !isRedirecting401) {
      isRedirecting401 = true;
      removeToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;